export const TOOL_GROUPS = [
    {
        id: "development",
        label: "Desarrollo",
        items: [
            { value: "api-client", label: "Cliente API" },
            { value: "json-yaml", label: "JSON / YAML" },
            { value: "jwt", label: "JWT" },
            { value: "encoder", label: "Encoder / Decoder" },
            { value: "hashes", label: "Hashes & UUID" },
            { value: "regex", label: "Regex Tester" },
            { value: "cron", label: "Cron Builder" },
            { value: "diff", label: "Diff" },
            { value: "sql", label: "SQL Tools" },
        ],
    },
    {
        id: "frontend",
        label: "Frontend",
        items: [
            { value: "playground", label: "Playground HTML/CSS/JS" },
            { value: "colors", label: "Colores y gradientes" },
            { value: "css", label: "Generador CSS" },
            { value: "layout", label: "Flexbox / Grid" },
            { value: "responsive", label: "Responsive" },
            { value: "svg", label: "SVG" },
            { value: "seo", label: "SEO / Meta" },
        ],
    },
    {
        id: "data",
        label: "Datos",
        items: [
            { value: "data-explorer", label: "Explorador de datos" },
            { value: "data-cleaner", label: "Limpieza de datos" },
            { value: "data-converter", label: "CSV / JSON" },
            { value: "statistics", label: "Estadística" },
            { value: "chart-builder", label: "Gráficos" },
        ],
    },
    {
        id: "ai",
        label: "IA",
        items: [
            { value: "prompt-lab", label: "Prompt Lab" },
            { value: "context-builder", label: "Context Builder" },
            { value: "llm-request", label: "LLM Request" },
            { value: "rag-planner", label: "RAG Planner" },
        ],
    },
    {
        id: "python",
        label: "Python",
        items: [
            { value: "python-lab", label: "Python Lab" },
            { value: "pandas-builder", label: "Pandas Builder" },
            { value: "python-environment", label: "Entorno Python" },
            { value: "pytest-builder", label: "Pytest Builder" },
        ],
    },
    {
        id: "agents",
        label: "Agentes",
        items: [
            { value: "agent-designer", label: "Diseñador de agentes" },
            { value: "tool-schema", label: "Tool Schema" },
            { value: "agent-workflow", label: "Workflow multiagente" },
            { value: "memory-planner", label: "Memoria" },
            { value: "agent-policy", label: "Políticas y guardrails" },
        ],
    },
];

export const TOOL_ITEMS = TOOL_GROUPS.flatMap((group) => group.items.map((item) => ({
    ...item,
    group: group.id,
    groupLabel: group.label,
    path: `/tools/${item.value}`,
})));

export const getToolByValue = (value) => TOOL_ITEMS.find((item) => item.value === value) ?? null;
